var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoneRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C1.54987e-07 11.7272 0.349188 9.97167 1.02763 8.33377C1.70607 6.69588 2.70047 5.20765 3.95406 3.95406C5.20765 2.70047 6.69588 1.70606 8.33378 1.02762C9.97167 0.349187 11.7272 -6.55159e-07 13.5 0C15.2729 6.55161e-07 17.0283 0.349189 18.6662 1.02763C20.3041 1.70607 21.7924 2.70047 23.0459 3.95406C24.2995 5.20765 25.2939 6.69588 25.9724 8.33378C26.6508 9.97168 27 11.7272 27 13.5L13.5 13.5L0 13.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2H15V5L14.5 8.5H13.5L13 5V2ZM13 10H15V12H13V10Z",
    fill: "#CDCDCD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 6,
    height: 3,
    fill: "#FF9696"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 6,
    height: 3,
    fill: "#FF9696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 21,
    width: 21,
    height: 3,
    fill: "#FF9696"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 6,
    height: 3,
    fill: "#FF9696"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 6,
    height: 3,
    fill: "#FF9696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoneRed);
export default __webpack_public_path__ + "static/media/bone-red.a8437207f73bf8081c1624d646f2c9f5.svg";
export { ForwardRef as ReactComponent };